//Function auxiliar to encriptarData
function importPublicKey(pem) {
  const publicKey = crypto.subtle.importKey(
    "jwk",
    JSON.parse(atob(pem)),
    {
      name: "RSA-OAEP",
      hash: "SHA-256",
    },
    true,
    ["encrypt"]
  );

  return publicKey;
}

//Auxiliar function to encriptarData
async function encryptData(publicKey: any, data: any) {
  // console.log({ data });
  const dataBuffer = new TextEncoder().encode(JSON.stringify(data));
  const encryptedData = await crypto.subtle.encrypt(
    {
      name: "RSA-OAEP",
    },
    publicKey,
    dataBuffer
  );
  return encryptedData;
}

//Auxiliar function to encriptarData
export function arrayBufferToHex(buffer: any) {
  const view = new Uint8Array(buffer);
  let hex = "";
  for (let i = 0; i < view.length; i++) {
    const byte = view[i].toString(16).padStart(2, "0");
    hex += byte;
  }
  return hex;
}

//Function to encript data
export async function encriptarDatos(public_key: any, jsonData: any) {
  const publicKey = await importPublicKey(public_key);
  const data = await encryptData(publicKey, jsonData);
  const b64 = arrayBufferToHex(data);
  return b64;
}
